import React, { useState } from 'react';

import { RadioButton } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { LoadingDataReducerStateType } from 'client/reducers/loadingData';
import * as keyset from 'i18n/Monitoring';

import styles from './AliceAppMonitoring.module.scss';
import { AliceAppMonitoringPageBarChart } from './AliceAppMonitoringPageBarChart';

const t = i18n(keyset);

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any[];
    labels: string[];
    dataLoadingState: LoadingDataReducerStateType;
    yAxisLabel?: string;
    displaySwitch?: boolean;
}

export const AliceAppMonitoringPageBarChartErrorSwitch: React.FC<Props> = (props) => {
    const [type, setType] = useState('abs');

    const labels = props.labels.filter((label) => label !== 'total');

    const newData =
        type === 'abs'
            ? props.data
            : props.data.map((bar) => {
                  const newBar = { ...bar, total: undefined };

                  labels.forEach((label) => {
                      const total = bar.total;

                      if (total === 0) {
                          newBar[label] = 0;
                      } else {
                          newBar[label] = ((bar[label] / total) * 100 || 0).toFixed(2);
                      }
                  });

                  return newBar;
              });

    return (
        <>
            {props.displaySwitch && (
                <div className={styles.chartSwitch}>
                    <RadioButton
                        value={type}
                        onUpdate={setType}
                        options={[
                            { value: 'abs', content: t('chart-switch-num') },
                            { value: 'perc', content: t('chart-switch-rate') },
                        ]}
                        disabled={props.dataLoadingState === 'loading'}
                    />
                </div>
            )}
            <AliceAppMonitoringPageBarChart {...props} data={newData} labels={labels} />
        </>
    );
};
